import { render } from "./ylyGlobalTemplate.vue?vue&type=template&id=4b31acb8&scoped=true"
import script from "./ylyGlobalTemplate.vue?vue&type=script&lang=js"
export * from "./ylyGlobalTemplate.vue?vue&type=script&lang=js"

import "./ylyGlobalTemplate.vue?vue&type=style&index=0&id=4b31acb8&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b31acb8"]])

export default __exports__